import React, { useEffect } from "react";
import fastFood from "../../assets/newLogo.jpeg";
import Footer from "../../components/Footer/Footer";
import styles from "./NewDeliveries.module.css";
import { Link } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import {
  getOrderAdmin,
  approveOrder,
  cancelOrder,
  markPickedOrder,
  markDeliveredOrder,
} from "../../redux/actions/orderActions";

const NewDeliveries = () => {
  const allOrder = useSelector((state) => state.orderAdmin);
  const { loading, orders, error } = allOrder;

  const { approvedOrder } = useSelector((state) => state.approvedOrder);

  const { cancOrder } = useSelector((state) => state.cancelOrder);

  const { markOrder } = useSelector((state) => state.markPickedOrder);

  const { delOrder } = useSelector((state) => state.markDeliveredOrder);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getOrderAdmin());
  }, [dispatch, approvedOrder, cancOrder, markOrder, delOrder]);

  const Approve = (id) => {
    dispatch(approveOrder(id));
  };

  const Cancelled = (id) => {
    dispatch(cancelOrder(id));
  };
  const Picked = (id) => {
    dispatch(markPickedOrder(id));
  };
  const delivered = (id) => {
    dispatch(markDeliveredOrder(id));
  };

  const len =
    orders &&
    orders
      .filter((order) => order.status !== "cancelled")
      .map((order) => <li>{order.length}</li>);

  const j =
    orders &&
    orders.map((ord) => {
      const t = ord.status !== "delivered";
      return t;
    });

  console.log(j);

  console.log(orders);

  return (
    <div className={styles.container}>
      <div className={styles.box}></div>
      <header>
        <h1>New Deliveries</h1>
        <Link to="/earnings">
          <p>Delivered</p>
        </Link>
      </header>
      <main>
        <p className={styles.status}>{len && len.length} Active Deliveries</p>

        {loading && <h2 className={styles.status}>Loading deliveries ...</h2>}
        {error && <h2>{error}</h2>}
        {orders &&
          orders.map((order) => (
            <div key={order._id}>
              {order.status !== "delivered" && (
                <div className={styles.card}>
                  <div className={styles.top}>
                    <div className={styles.name}>
                      <img src={fastFood} alt="fast-food" />
                      <div className={styles.nameText}>
                        <Link to={`/delivery-info/${order._id}`}>
                          <h3>{order.typeOfOrder}</h3>
                        </Link>
                        <small>Economy Delivery</small>
                      </div>
                    </div>
                    <div className={styles.btnContainer}>
                      {order.status === "accepted" ? (
                        <>
                          <button
                            style={{
                              backgroundColor: "#18254a",
                              color: "white",
                            }}
                            onClick={() => Picked(order._id)}
                          >
                            Mark Picked
                          </button>
                        </>
                      ) : order.status === "picked" ? (
                        <>
                          <button
                            style={{
                              backgroundColor: "#18254a",
                              color: "white",
                            }}
                            onClick={() => delivered(order._id)}
                          >
                            Mark Delivered
                          </button>
                        </>
                      ) : order.status === "pending" ? (
                        <>
                          <button onClick={() => Cancelled(order._id)}>
                            <i className="far fa-times-circle"></i>
                          </button>
                          <button onClick={() => Approve(order._id)}>
                            Accept
                          </button>
                        </>
                      ) : order.status === "delivered" ? (
                        <button
                          style={{
                            backgroundColor: "transparent",
                            color: "#18254a",
                            border: "1px solid #18254a",
                          }}
                        >
                          Delivered
                        </button>
                      ) : (
                        <button
                          style={{
                            backgroundColor: "transparent",
                            color: "red",
                            border: "1px solid red",
                          }}
                        >
                          Cancelled
                        </button>
                      )}
                    </div>
                  </div>
                  <div className={styles.middle}>
                    <div className={styles.mode}>
                      <small>Payment mode</small>
                      <p> {order.payment}</p>
                    </div>
                    <div className={styles.payment}>
                      <small>Payment</small>
                      <p>$ {order.payment_amount}</p>
                    </div>
                  </div>
                  <div className={styles.bottom}>
                    <p>{order.pickup.personName}</p>
                    <div className={styles.locationIcons}>
                      <i className={styles.icon + " fas fa-map-marker-alt"}></i>
                      <span>......</span>
                      <i className={styles.icon + " fas fa-location-arrow"}></i>
                    </div>
                    <p>{order.dropoff.personName}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
      </main>
      <Footer />
    </div>
  );
};

export default NewDeliveries;
